module.exports = __webpack_public_path__ + "static/media/cardImage.a9f10747.jpg";